@if (ngControl.control != null) {
  <p-select
    appendTo="body"
    [placeholder]="placeholder || ' '"
    [options]="options"
    [formControl]="ngControl.control | abstractControlToFormControl"
    [filter]="showFilter"
    [showClear]="showClear"
    [filterPlaceholder]="filterPlaceholder"
    (onClear)="clearSelect($event)"
    (onChange)="onChange.emit($event)">
    <ng-template let-item pTemplate="selectedItem">
      @if (ngControl.value) {
        <span class="value">
          {{ item.label }}
        </span>
      }
      @if (ngControl.control.disabled) {
        <shared-icon class="disabled-icon" icon="lock" height="1rem" width="1rem" />
      }
    </ng-template>
    <ng-template let-item pTemplate="item">
      @if (showLogo) {
        <img [src]="item.icon" />
      }
      <span>{{ item.label }}</span>
    </ng-template>
    <ng-template pTemplate="dropdownicon">
      <shared-icon icon="arrow-down" width="0.75rem" />
    </ng-template>
  </p-select>
}
